import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf
       } from '@angular/core';

import { MatModule } from './material/mat.module';

import { ConfigService } from './config/config.service';
import { ErrorService } from './error/error.service';
import { FontStoreService } from './fontstore/fontstore.service';
import { ImageStoreService } from './imagestore/imagestore.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoggingService } from './logging/logging.service';
import { PriceCalculationService } from './price/price-calculation.service';
import { ProductUpgradeService
       } from './product-upgrade/product-upgrade.service';
import { ProductService } from './product/product.service';
import { ProductdesignerdService
       } from './productdesignerd/productdesignerd.service';
import { SteinService } from './stein/stein.service';

@NgModule({
  imports: [ CommonModule, MatModule ],
  declarations: [],
  exports: [ ],
})
export class CoreModule
{
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
          ConfigService,
          ErrorService,
          ImageStoreService,
          FontStoreService,
          LoggingService,
          PriceCalculationService,
          ProductdesignerdService,
          ProductService,
          SteinService,
          ProductUpgradeService,
          {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
          },
      ],
    };
  }

  constructor (@Optional() @SkipSelf() parentModule: CoreModule)
  {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts